import type { CnFunction } from "cn";
import { createCn } from "cn/engine";
import tables from "./generated/cn-tables";

export const cn: CnFunction = createCn(tables);
